export const signupPageObject = () => ({
    googleSignupButton: document.getElementById("providerButton_google2"),
    appleSignupButton: document.getElementById("providerButton_apple"),
    submitButton: document.getElementById("signup-submit"),
    agreeCheckbox: document.getElementById("agreeCheckBox"),
    alreadyHaveAccount: document.getElementById("already-have-account"),
    signupCodeSubmit: document.getElementById("passwordless-submit-btn"),
    resendCode: document.getElementById("passwordless-resend-button"),
    backSignupCode: document.getElementById("signup-code-back")
})
